import React from 'react';
import { Button, Tooltip, message, Space } from 'antd';
import { PlayCircleOutlined, RedoOutlined, PauseCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { BASE_URL as BASEURL, RESTART, PAUSE, RESUME, REQUEST, CANCEL } from '../Constants/URLs';
import { patchAPI, postAPI } from '../Services/Api';
import { REQUEST_STATUS_VALUES } from '../Constants/Constants';

// Pause / resume / cancel / restart buttons for a request, based on its status.
// onLoadingChange(bool) is called around the API call, onSuccess() after it succeeds.
const RequestActions = ({ requestId, status, onLoadingChange = () => {}, onSuccess = () => {} }) => {
  const requestActionHandler = action => {
    onLoadingChange(true);
    let payload = {};

    let url = BASEURL + REQUEST + requestId;
    if (action === RESTART) url = BASEURL + RESTART;
    else if (action === PAUSE) url = url + PAUSE;
    else if (action === RESUME) url = url + RESUME;
    else if (action === CANCEL) url = BASEURL + REQUEST + CANCEL;

    if (action === PAUSE || action === RESUME) {
      patchAPI(url, payload)
        .then(() => {
          let messageText;
          if (action === PAUSE) messageText = `${requestId} paused successfully`;
          else if (action === RESUME) messageText = `${requestId} resumed successfully`;
          message.success(messageText, 1);
          onSuccess();
        })
        .finally(() => {
          onLoadingChange(false);
        });
    } else {
      let user = JSON.parse(sessionStorage.getItem('user'));
      payload = {
        request_id: requestId,
        user_name: user.email
      };
      if (action === RESTART) {
        postAPI(url, payload)
          .then(() => {
            message.success(`${requestId} restarted successfully`, 1);
            onSuccess();
          })
          .finally(() => {
            onLoadingChange(false);
          });
      } else if (action === CANCEL) {
        patchAPI(url, payload)
          .then(() => {
            message.success(`${requestId} Cancelled successfully`, 1);
            onSuccess();
          })
          .finally(() => {
            onLoadingChange(false);
          });
      }
    }
  };

  // only for failed show restart.
  // completed -> no action
  // in progress , pending -> pause/resume action
  if (status === REQUEST_STATUS_VALUES.PENDING || status === REQUEST_STATUS_VALUES.IN_PROGRESS) {
    return (
      <Space>
        <Tooltip title='Pause this request'>
          <Button
            type='primary'
            icon={<PauseCircleOutlined />}
            shape='circle'
            onClick={() => requestActionHandler(PAUSE)}></Button>
        </Tooltip>
        <Tooltip title='Cancel this request'>
          <Button
            type='primary'
            icon={<CloseOutlined />}
            shape='circle'
            danger={true}
            onClick={() => requestActionHandler(CANCEL)}></Button>
        </Tooltip>
      </Space>
    );
  }
  if (status === REQUEST_STATUS_VALUES.FAILED) {
    return (
      <Tooltip title='Restart this request'>
        <Button
          type='primary'
          icon={<RedoOutlined />}
          shape='circle'
          onClick={() => requestActionHandler(RESTART)}></Button>
      </Tooltip>
    );
  }
  if (status === REQUEST_STATUS_VALUES.PAUSED) {
    return (
      <Tooltip title='Resume this request'>
        <Button
          type='primary'
          icon={<PlayCircleOutlined />}
          shape='circle'
          onClick={() => requestActionHandler(RESUME)}></Button>
      </Tooltip>
    );
  }
  return <Button type='dashed' icon={<PlayCircleOutlined />} shape='circle' disabled></Button>;
};

export default RequestActions;
